<template>
  <div class="course_list mar_top_10">
    <div class="flex FlexBetween">
      <div class="recommend">猜你想学</div>
      <div class="more_btn flex Flexalign Flexjustify cursor_pointer" @click="goCourseList">
        更多
        <div class="flex Flexalign" style="margin-left: 5px">
          <el-icon :size="18">
            <ArrowRight color="rgba(102, 102, 102, 1)" />
          </el-icon>
        </div>
      </div>
    </div>
    <div class="flex course_one flexcolumn FlexEvenly cursor_pointer" v-for="(item, index) in rankList" :key="index"
      @click="goCourseDetail(item)">
      <div class="course_rank_list flex-1 flex FlexWrap FlexBetween">
        <div class="course_rank_one_right flex-1 flex">
          <div>
            <el-image class="course_one_img" :src="imgPath(item.courseCoverImg)"></el-image>
          </div>
          <div class="course_info flex-1">
            <div class="flex flexcolumn FlexBetween ">
              <el-tooltip class="box-item" :content="item.courseName" placement="right" effect="customized" :show-after="1000" :show-arrow='false'>
                <div class="course_title toverflow">{{ item.courseName }}</div>
              </el-tooltip>
              <div class="flex FlexBetween Flexalign course_online_info">
                <div class="course_online toverflow">
                  {{ item.shopName }}
                </div>
                <div class="course_online">{{ item.chapterCountResult?.chapterNum || 0 }}课时</div>
              </div>
              <div class="course_rate flex Flexalign FlexBetween">
                <el-rate v-model="item.rate" disabled show-score text-color="#666666" score-template="{value}分"
                  size="small" />
                <!-- <div class="course_price">
                  <span class="course_price_unit">￥</span>{{ (item.saleMethod == 2) ? item.coursePrice : 0 }}
                </div> -->
                <div class="course_price" v-if="item.saleMethod == 2">
                  <span class="course_price_unit">￥</span>{{ item.saleMethod == 2 ? item.coursePrice : 0 }}
                </div>
                <div class="course_price course_free" v-else>免费</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "GjkcH5RecommendCourseList",
  props: {
    courseDetail: {},
  },
  computed: {
    ...mapState({
      selectCourseType: (state) => state.user.selectCourseType,
    }),
  },
  watch: {
    courseDetail: {
      handler(value) {
        if (!value) return;
        if (value.shopId) {
          this.selectedInfo.shopId = this.courseDetail.shopId;
          this.selectedInfo.subjectId = this.courseDetail.subjectId;
          this.getCourseList();
        }
      },
      immediate: true,
      deep: true
    },
    selectCourseType: {
      handler(value) {
        this.selectedInfo.typeId = value;
        this.getCourseList();
      },
      deep: true,
      immediate: true
    },
  },

  data() {
    return {
      rankList: [],

      selectedInfo: {
        shopId: "", // 商家Id
        courseName: "", // 课程名
        stageId: "", // 所属学段ID
        gradeId: "", // 所属年级ID
        subjectId: "", // 所属学科ID
        termId: "", // 所属学期ID
        publisherId: "", // 所属版本ID
        courseBookType: "", // 课程课本类型（1=课本课程，2=自定义课程）
        textbookId: "", // 所属教材ID
        courseDifficulty: "", // 课程难度
        learningStyle: "", // 学习方式（1=不限、2=闯关学习）
        saleMethod: "", // 售卖方式（1=免费，2=付费）
        pointsUsable: "", // 积分抵扣（1=允许，2=不允许）
        page: 1, // 页码
        pageSize: 5, // 单页数量
        orderByColumn: 'hot_sales', // 猜你想学
        typeId: '',  // 课程类型
      },
    };
  },

  mounted() {
    // this.getCourseList();
  },

  methods: {
    // 获取课程列表
    getCourseList() {
      this.$Api.course
        .getCourseList(this.selectedInfo)
        .then((res) => {
          this.rankList = res.data.data.list;
          this.rankList.forEach((item) => {
            item.rate = this.$Tools.scoreToStar(item.courseExtra.appraiseScore);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 课程列表页
    goCourseList() {
      this.$Jump.href("/courseList", {
        selectedParams: JSON.stringify(this.selectedInfo),
      });
    },
    // 详情
    goCourseDetail(info) {
      this.$Jump.href("/courseDetail", { courseId: info.courseId });
    },
  },
};
</script>

<style lang="scss" scoped>
.course_list {
  width: 330px;
  // margin-top: 10px;
  // width: 100%;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 20px;

  .recommend {
    font-weight: bold;
    font-size: 18px;
    color: #111111;
  }

  .more_btn {
    color: rgba(102, 102, 102, 1);
  }

  .course_one {
    background: #ffffff;
    border-radius: 10px;
    width: 100%;
    margin-top: 15px;

    .course_title {
      // width: 30%;
      // font-weight: bold;
      font-size: 18px;
      color: #111111;
    }

    .course_rank_list {
      .course_rank_one_right {
        width: 100%;
      }

      .course_one_img {
        width: 100px;
        height: 70px;
        border-radius: 10px;
      }

      .course_info {
        width: calc(100% - 110px);
        height: 70px;
        margin-left: 11px;

        .course_rate {
          :deep(.el-rate .el-rate__icon) {
            margin-right: 0;
          }

          :deep(.el-rate) {
            height: auto;
          }

          .course_price {
            color: #ff6619;
            font-size: 18px;
            font-weight: 600;

            .course_price_unit {
              font-size: 16px;
              font-weight: 400;
            }
          }

          .course_free {
            font-size: 16px;
            font-weight: 400;
          }
        }

        .course_online_info {
          .course_online {
            max-width: 150px;
            font-size: 14px;
            color: #999999;
          }
        }
      }
    }
  }
}
</style>
